var ButtonMask;
(function (ButtonMask) {
  ButtonMask[ButtonMask["NONE"] = 0] = "NONE";
  ButtonMask[ButtonMask["CIRCLE"] = 1] = "CIRCLE";
  ButtonMask[ButtonMask["MASK_BUTTON"] = 2] = "MASK_BUTTON";
})(ButtonMask || (ButtonMask = {}));

export { ButtonMask };
//# sourceMappingURL=types.js.map
